import React, { useEffect, useState } from 'react';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';

import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';

import { FaHistory, FaUserCog, FaFileContract, FaStore } from 'react-icons/fa';
import { RiBattery2ChargeFill } from 'react-icons/ri';
import { LuNotebookText } from 'react-icons/lu';

import { ImExit } from 'react-icons/im';
import { FaBuildingFlag } from 'react-icons/fa6';
import { HiOutlineReceiptTax } from 'react-icons/hi';
import { TbLayersSubtract } from 'react-icons/tb';
import { GrTransaction, GrConnect } from 'react-icons/gr';
import { FaMoneyBillTrendUp } from 'react-icons/fa6';

import logo from '../../assets/logo-final-horizontal.png';

import { ContainerMenu } from './style.js';
import api from '../../services/api.js';

const Menu = () => {
  const navigate = useNavigate();

  const [isVisible, setIsVisible] = useState(false);
  const [profile, setProfile] = useState(false);

  const logout = () => {
    localStorage.removeItem('ID_DM900');
    localStorage.removeItem('DS_EMAIL_LOGIN');
    localStorage.removeItem('NM_USUARIO');
    localStorage.removeItem('IN_TIPO');
    localStorage.removeItem('TOKEN');

    navigate('/');
  };

  const getProfile = () => {
    let url = 'user';
    api
      .get(url)
      .then((response) => {
        setProfile(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getProfile();
    // Adicionar classe ao body para compensar o menu lateral
    document.body.classList.add('with-sidebar');
    
    // Cleanup: remover a classe quando o componente for desmontado
    return () => {
      document.body.classList.remove('with-sidebar');
      document.body.classList.remove('sidebar-collapsed');
    };
  }, []);

  // Gerenciar o estado do menu (expandido/colapsado)
  useEffect(() => {
    if (isVisible) {
      document.body.classList.remove('sidebar-collapsed');
    } else {
      document.body.classList.add('sidebar-collapsed');
    }
  }, [isVisible]);

  return (
    <>
      <ContainerMenu>
        <SideNav
          expanded={isVisible}
          onSelect={(selected) => {
            navigate('/' + selected);
          }}>
          <SideNav.Toggle
            onClick={() => {
              setIsVisible(!isVisible);
            }}
          />
          <SideNav.Nav>
            <div id="imgLogoMenu" style={{ textAlign: 'center' }}>
              <img
                src={logo}
                style={{
                  opacity: isVisible ? '1' : '0',
                  width: isVisible ? '120px' : '0px'
                }}
                alt="Logo"
              />
              {isVisible ? (
                <div
                  style={{
                    marginTop: '5px',
                    marginBottom: '15px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    color: '#ecf0f1'
                  }}>
                  {profile.data.user.name}
                </div>
              ) : (
                <></>
              )}
            </div>
            <NavItem eventKey="study/list">
              <NavIcon>
                <LuNotebookText
                  style={{
                    color: '#ecf0f1'
                  }}
                  className="anchor-element"
                  data-tooltip-content="Estudos"
                  data-place="right"
                />
              </NavIcon>
              <NavText
                style={{
                  color: '#ecf0f1'
                }}
                className="optMenu">
                Estudos
              </NavText>
            </NavItem>
            <NavItem eventKey="supplier/list">
              <NavIcon>
                <RiBattery2ChargeFill
                  style={{
                    color: '#ecf0f1'
                  }}
                  className="anchor-element"
                  data-tooltip-content="Distribuidoras"
                  data-place="right"
                />
              </NavIcon>
              <NavText
                style={{
                  color: '#ecf0f1'
                }}
                className="optMenu">
                Distribuidoras
              </NavText>
            </NavItem>

            <NavItem eventKey="distribution_fee/list">
              <NavIcon>
                <HiOutlineReceiptTax
                  style={{
                    color: '#ecf0f1'
                  }}
                  className="anchor-element"
                  data-tooltip-content="Tarifa por Distribuidora"
                  data-place="right"
                />
              </NavIcon>
              <NavText
                style={{
                  color: '#ecf0f1'
                }}
                className="optMenu">
                Tarifa por Distribuidora
              </NavText>
            </NavItem>
            <NavItem eventKey="energy/list">
              <NavIcon>
                <FaBuildingFlag
                  style={{
                    color: '#ecf0f1'
                  }}
                  className="anchor-element"
                  data-tooltip-content="Bandeira Tarifária"
                  data-place="right"
                />
              </NavIcon>
              <NavText
                style={{
                  color: '#ecf0f1'
                }}
                className="optMenu">
                Bandeira Tarifária
              </NavText>
            </NavItem>
            <NavItem eventKey="sub_class/list">
              <NavIcon>
                <TbLayersSubtract
                  style={{
                    color: '#ecf0f1'
                  }}
                  className="anchor-element"
                  data-tooltip-content="Subclasses"
                  data-place="right"
                />
              </NavIcon>
              <NavText
                style={{
                  color: '#ecf0f1'
                }}
                className="optMenu">
                Subclasses
              </NavText>
            </NavItem>
            {/* <NavItem eventKey="gd2/list">
              <NavIcon>
                <GrTransaction
                  style={{
                    color: '#ecf0f1'
                  }}
                  className="anchor-element"
                  data-tooltip-content="GD2 Transição"
                  data-place="right"
                />
              </NavIcon>
              <NavText
                style={{
                  color: '#ecf0f1'
                }}
                className="optMenu">
                GD2 Transição
              </NavText>
            </NavItem> */}
            <NavItem eventKey="flag_hist/list">
              <NavIcon>
                <FaHistory
                  style={{
                    color: '#ecf0f1'
                  }}
                  className="anchor-element"
                  data-tooltip-content="Histórico de Bandeiras"
                  data-place="right"
                />
              </NavIcon>
              <NavText
                style={{
                  color: '#ecf0f1'
                }}
                className="optMenu">
                Histórico de Bandeiras
              </NavText>
            </NavItem>
            <NavItem eventKey="flag_economy/list">
              <NavIcon>
                <FaMoneyBillTrendUp
                  style={{
                    color: '#ecf0f1'
                  }}
                  className="anchor-element"
                  data-tooltip-content="Economia de Bandeiras"
                  data-place="right"
                />
              </NavIcon>
              <NavText
                style={{
                  color: '#ecf0f1'
                }}
                className="optMenu">
                Economia de Bandeiras
              </NavText>
            </NavItem>
            <NavItem eventKey="connection_type/list">
              <NavIcon>
                <GrConnect
                  style={{
                    color: '#ecf0f1'
                  }}
                  className="anchor-element"
                  data-tooltip-content="Tipo de conexão"
                  data-place="right"
                />
              </NavIcon>
              <NavText
                style={{
                  color: '#ecf0f1'
                }}
                className="optMenu">
                Tipo de conexão
              </NavText>
            </NavItem>
            <NavItem eventKey="user/list">
              <NavIcon>
                <FaUserCog
                  style={{
                    color: '#ecf0f1'
                  }}
                  className="anchor-element"
                  data-tooltip-content="Usuários"
                  data-place="right"
                />
              </NavIcon>
              <NavText
                style={{
                  color: '#ecf0f1'
                }}
                className="optMenu">
                Usuários
              </NavText>
            </NavItem>
            <NavItem eventKey="sales_channel/list">
              <NavIcon>
                <FaStore
                  style={{
                    color: '#ecf0f1'
                  }}
                  className="anchor-element"
                  data-tooltip-content="Canais de Venda"
                  data-place="right"
                />
              </NavIcon>
              <NavText
                style={{
                  color: '#ecf0f1'
                }}
                className="optMenu">
                Canais de Venda
              </NavText>
            </NavItem>
            <NavItem eventKey="templates">
              <NavIcon>
                <FaFileContract
                  style={{
                    color: '#ecf0f1'
                  }}
                  className="anchor-element"
                  data-tooltip-content="Templates D4Sign"
                  data-place="right"
                />
              </NavIcon>
              <NavText
                style={{
                  color: '#ecf0f1'
                }}
                className="optMenu">
                Templates D4Sign
              </NavText>
            </NavItem>
            {/* <NavItem eventKey="parameters">
              <NavIcon>
                <BsGearFill
                  style={{
                    color: '#ecf0f1'
                  }}
                  className="anchor-element"
                  data-tooltip-content="Parâmetros"
                  data-place="right"
                />
              </NavIcon>
              <NavText
                style={{
                  color: '#ecf0f1'
                }}
                className="optMenu">
                Parâmetros
              </NavText>
            </NavItem> */}

            <NavItem eventKey="" onClick={logout}>
              <NavIcon>
                <ImExit
                  style={{
                    color: '#ecf0f1'
                  }}
                  className="anchor-element"
                  data-tooltip-content="Sair"
                  data-place="right"
                />
              </NavIcon>
              <NavText
                style={{
                  color: '#ecf0f1'
                }}
                className="optMenu">
                Sair
              </NavText>
            </NavItem>
          </SideNav.Nav>
        </SideNav>
      </ContainerMenu>
      <Tooltip anchorSelect=".anchor-element" style={{ zIndex: '10000' }} place="right" />
    </>
  );
};

export default Menu;
